"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateDiff = void 0;
var TimeSpan_1 = require("../TimeSpan");
/**
 * Oblicza różnicę pomiędzy datami
 * @param lateDate data późniejsza
 * @param earlyDate data wcześniejsza
 */
function dateDiff(lateDate, earlyDate) {
    return TimeSpan_1.TimeSpan.diff(lateDate, earlyDate);
}
exports.dateDiff = dateDiff;
exports.default = dateDiff;
//# sourceMappingURL=dateDiff.js.map